
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BaseModal',
  props: {
    isVisible: { type: Boolean, required: true },
    title: { type: String, default: 'Подтверждение' },
  },
  emits: ['close'],
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
})
